import { Link } from 'react-router-dom';

export default function CheckoutCancelPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Cancel icon */}
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-slate-700/50 flex items-center justify-center">
          <svg
            className="w-10 h-10 text-purple-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-white mb-4">Checkout Canceled</h1>

        <p className="text-purple-300 mb-8">
          Your payment was not completed. No charges have been made to your account.
        </p>

        <div className="space-y-3">
          <Link
            to="/profile"
            className="block w-full px-6 py-3 bg-purple-600 hover:bg-purple-500 text-white font-medium rounded-xl transition-colors"
          >
            Back to Profile
          </Link>

          <Link
            to="/"
            className="block w-full px-6 py-3 text-purple-300 hover:text-white transition-colors"
          >
            Continue Reading
          </Link>
        </div>
      </div>
    </div>
  );
}
